module.exports = __webpack_public_path__ + "img/car-category.90f20409.jpg";